import React from "react";
import { useMutation } from "@apollo/client";
import { BreadcrumbItem, Card, CardBody, Container, CustomInput } from "reactstrap";
import * as Notify from "@repoflow/form-schema/notify";
import * as Loading from "@repoflow/components/loading";
import * as SettingsQL from "queries/settings";
import { MEALS, MEAL_LABELS } from "components/day/summary";
import { useMeals } from "components/settings/meals";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Settings</BreadcrumbItem>;

// How the organization's food log is shown. One card for now: the meals.
export const Content = () => (
  <Container className="mt-4" style={{ maxWidth: 760 }}>
    <h4 className="m-0">Settings</h4>
    <MealsCard />
  </Container>
);

// A switch per meal, saved as it is flipped. A meal turned off is left off
// the day screen, the chat's panel, the add-food form and the dashboard's
// breakdown, and the chat stops logging to it. The last one on cannot be
// turned off: the server refuses a food log with no meal, and a switch that
// cannot be flipped says so before it is tried.
//
// No optimistic answer: the save answers under the cached settings' own id,
// so every screen follows as soon as it lands, and until then the switches
// are held still rather than showing a state that might not stick.
const MealsCard = () => {
  const shown = useMeals();
  const [save, { loading: saving }] = useMutation(SettingsQL.save, {
    onError: (error) => Notify.error(String(error)),
  });

  const toggle = (meal) => {
    const meals = shown.includes(meal) ? shown.filter((m) => m !== meal) : [...shown, meal];
    save({ variables: { input: { meals } } });
  };

  return (
    <Card className="mt-3" data-testid={"settings-meals"}>
      <CardBody>
        <h5>Meals</h5>
        <p className="text-muted small">
          The meals your food log is kept in. A meal turned off is hidden from the day, the chat and the add-food
          form, and the chat stops logging to it. At least one stays on.
        </p>
        {!shown ? (
          <Loading.Icon />
        ) : (
          MEALS.map((meal) => {
            const on = shown.includes(meal);
            return (
              <CustomInput
                key={meal}
                type={"switch"}
                id={`settings-meal-${meal}`}
                label={MEAL_LABELS[meal]}
                checked={on}
                disabled={saving || (on && shown.length === 1)}
                onChange={() => toggle(meal)}
                className="mb-2"
              />
            );
          })
        )}
      </CardBody>
    </Card>
  );
};
